// theme.js or theme/index.js

import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  colors: {
    brand: {
      50: '#f7fafc',
      100: '#edf2f7',
      200: '#e2e8f0',
      300: '#cbd5e0',
      400: '#a0aec0',
      500: '#718096', // Primary color: medium gray (use this as the main brand color)
      600: '#4a5568',
      700: '#2d3748',
      800: '#1a202c',
      900: '#171923',
    },
    card: {
      coral: '#D4674A',   // warm terracotta/salmon (GoodNotes-style)
      yellow: '#F5D53F',  // vivid bright yellow (GoodNotes-style)
      green: '#3DAA6E',   // solid green
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'bold',
        borderRadius: 'full',
      },
      sizes: {
        lg: {
          fontSize: 'lg',
          px: 6,
          py: 4,
        },
      },
      variants: {
        solid: (props) => ({
          bg: props.colorMode === 'dark' ? 'brand.500' : 'brand.600',
          color: 'white',
          _hover: {
            bg: props.colorMode === 'dark' ? 'brand.600' : 'brand.500',
          },
        }),
        outline: {
          borderColor: 'brand.500',
          color: 'brand.500',
          _hover: {
            bg: 'brand.50',
          },
        },
        ghost: {
          color: 'brand.900',
          _hover: {
            bg: 'brand.50',
          },
        },
      },
    },
    Switch: {
      baseStyle: {
        track: {
          _checked: {
            bg: 'brand.500', // Track color when the switch is on
          },
          bg: 'gray.300', // Track color when the switch is off
        },
        thumb: {
          _checked: {
            bg: 'white', // Thumb color when the switch is on
          },
          bg: 'gray.100', // Thumb color when the switch is off
        },
      },
    },
    Checkbox: {
        baseStyle: {
          control: {
            _checked: {
              bg: 'brand.500', // Background color when checked
              borderColor: 'brand.500', // Border color when checked
              color: 'white', // Checkmark color
              _hover: {
                bg: 'brand.600', // Darker background on hover when checked
                borderColor: 'brand.600',
              },
            },
            borderColor: 'gray.300', // Border color when unchecked
            _hover: {
              borderColor: 'brand.500', // Hover border color when unchecked
            },
          },
        },
    },

    Tooltip: {
      baseStyle: {
        borderRadius: 'lg',
      },
    },

    Tabs: {
        baseStyle: {
          tab: {
            fontWeight: 'bold',
            _selected: {
              color: 'brand.500', // Color for selected tab text
              borderColor: 'brand.500', // Border color for selected tab
            },
            _hover: {
              color: 'brand.600', // Darker shade on hover
            },
          },
        },
        variants: {
          line: {
            tab: {
              _selected: {
                borderColor: 'brand.500', // Line variant selected border color
              },
            },
          },
          enclosed: {
            tab: {
              _selected: {
                bg: 'brand.50', // Background color for selected enclosed tab
                color: 'brand.500',
                borderColor: 'brand.500',
              },
            },
          },
        },
      },



  },
});

export default theme;
